<div modalHeader class="modal-header">
  <h2>Change Role</h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn pt-1" (click)="close()"></tr-icon>
</div>

<div modalContent class="modal-body" *ngIf="form">
  <form [formGroup]="form">
    <div class="form-group">
      <div class="user-info" role="alert">
        <span class="d-flex flex-column">
          <p class="mb-0">USER EMAIL</p>
          <p class="mb-0 font-weight-bold" [innerText]="user.email"></p>
        </span>
      </div>
    </div>

    <div class="form-group">
      <div class="user-info" role="alert">
        <span class="d-flex flex-column">
          <p class="mb-0">USER FULL NAME</p>
          <p class="mb-0 font-weight-bold" [innerText]="user.name"></p>
        </span>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">Role</label>
      <tablesready-btn-group-control
        bindName="name"
        bindValue="value"
        [items]="roles"
        [control]="roleControl"
        [buttonType]="buttonsColor.success"
      ></tablesready-btn-group-control>
      <control-messages [control]="roleControl"></control-messages>
    </div>
  </form>
</div>

<div modalFooter class="d-flex pt-3">
  <div class="form-group col">
    <button
      class="btn btn-info w-100"
      [disabled]="!form.touched || !form.valid || inProgress"
      (click)="updateUser()"
    >Save changes</button>
  </div>

  <div class="form-group col">
    <button class="btn btn-danger w-100" (click)="close()" [disabled]="inProgress">Cancel</button>
  </div>
</div>
